module.exports = __webpack_public_path__ + "mInboxalteration-Icon.png?b65e43c401f4ff5aae0771d5ee80df80";